<template>
    <li :class="['nav-item dropdown', appnav == 'false' ? 'd-none' : '']">
        <a href="#" class="nav-link dropdown-toggle" id="navbarDropdownScreenLink" data-toggle="dropdown"><i class="fas fa-desktop"></i> Screen</a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownScreenLink">
            <a :class="['dropdown-item pt-1 pb-1', screentype == '' ? 'text-success': '']" href="#" @click="setScreen('')">Single Screen</a>
            <a :class="['dropdown-item pt-1 pb-1', screentype == 'top' ? 'text-success': '']" href="#" @click="setScreen('top')">Top Screen</a>
            <a :class="['dropdown-item pt-1 pb-1', screentype == 'bottom' ? 'text-success': '']" href="#" @click="setScreen('bottom')">Touch Input</a>
        </div>
    </li>
</template>

<script>
import axios from 'axios';
    export default {
        props: ['user', 'appnav'],
        mounted() {
            this.setActiveScreenType();
            Echo.channel(`screen.${this.user.id}`)
            .listen('.url.changed', (e) => {
                // if (window.name != "")
                    this.redirectTo(e.url);
            })
            this.redirectFromDashBoard();
            console.log(this.appnav)
        },
        data () {
            return {
                screentype: '',
            }
        },
        methods: {
            setScreen(typ) {
                window.name = typ;
                this.screentype = typ;
            },
            setActiveScreenType() {
                if (new URL(location.href).searchParams.get('window')) {
                    window.name = new URL(location.href).searchParams.get('window');
                }
                this.screentype = window.name;
            },
            redirectFromDashBoard() {
                if (window.name == "") return;
                if (window.name == "bottom" && window.location.href.indexOf("dashboard") != -1) {
                    this.redirectTo("/matchrequests/create");
                }

                if (window.name == "top" && (window.location.href.indexOf("dashboard") != -1 || window.location.href.indexOf("matchrequests") != -1)) {
                    this.redirectTo("/banner");
                }
            },
            redirectTo(url) {
                location.href = url
            },
            test() {
                axios.post("/matchrequests/testURLChange");
            }

        }
    }
</script>
